module.exports = __webpack_public_path__ + "static/searching-17d7e4d332114403cca08674c003ae20.svg";